import { api } from "../api";

/**
 * findAllDevicesProtocolsByManufacturerIdListResponse - Function that finds on database all devices protocols by manufacturer id as select list response
 * /devices/protocols/{manufacturedId}  
 * method GET 
 * @async-function
 */
const findAllDevicesProtocolsByManufacturerIdListResponse = async (token: string, manufacturerId: number) => {
    const response = await api.get(
        `/devices/protocols/${manufacturerId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default findAllDevicesProtocolsByManufacturerIdListResponse;